"use client";
import {NeoButton, NeoTextBox} from "@/components/forms";
import {yupResolver} from "@hookform/resolvers/yup";
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {AiOutlineLoading} from "react-icons/ai";
import * as yup from "yup";

interface FleetFormProps {
  id?: string;
  name: string;
  phone?: string;
  address?: string;
}

interface FleetProps {
  header: string;
  datas: any;
  onSubmit: () => void;
}

export const FleetForm: React.FC<FleetProps> = ({header, datas, onSubmit}) => {
  const [defaultValues, setDefaultValue] = useState<FleetFormProps>({
    id: datas?.id || "",
    name: datas?.name || "",
    phone: datas?.phone || "",
    address: datas?.address || ""
  });

  useEffect(() => {
    setDefaultValue(datas);
  }, [datas]);

  const validationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    phone: yup
      .string()
      .nullable()
      .transform(value => (value === "" ? null : value))
      .matches(/^\d+$/, "Phone must be number")
      .notRequired(),
    address: yup.string().nullable().notRequired()
  });

  const {
    register,
    handleSubmit,
    control,
    setError,
    clearErrors,
    formState: {isSubmitting, errors},
    reset
  } = useForm({
    defaultValues,
    mode: "onTouched",
    resolver: yupResolver(validationSchema)
  });

  return (
    <div>
      <h2 className="mb-3 text-lg font-semibold">{header}</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col-span-4 py-2 lg:col-span-1">
          <NeoTextBox
            label={
              <>
                Name <span className="text-red-500">*</span>
              </>
            }
            id="name"
            placeholder="Please enter name"
            color={errors.name ? "danger" : "default"}
            isInvalid={errors.name ? true : false}
            errorMessage={errors.name?.message}
            {...register("name")}
            defaultValue={defaultValues?.name}
          />
        </div>
        {header !== "Expense Type" &&
          header !== "Service Type" &&
          header !== "Fuel Station" && (
            <>
              <div className="col-span-4 py-2 lg:col-span-1">
                <NeoTextBox
                  label="Phone"
                  id="phone"
                  placeholder="Please enter phone"
                  color={errors.phone ? "danger" : "default"}
                  isInvalid={errors.phone ? true : false}
                  errorMessage={errors.phone?.message}
                  {...register("phone")}
                  defaultValue={defaultValues?.phone}
                />
              </div>
            </>
          )}
        {header !== "Expense Type" && header !== "Service Type" && (
          <>
            <div className="col-span-4 py-2 lg:col-span-1">
              <label
                htmlFor="address"
                className="text-md mb-1 block font-medium text-gray-700"
              >
                Address
              </label>
              <Controller
                name="address"
                control={control}
                defaultValue={defaultValues?.address}
                render={({field}) => (
                  <>
                    <textarea
                      {...field}
                      value={field.value ?? ""}
                      className="w-full rounded-[17px] border-2 p-3 shadow-none hover:border-gray-600 focus:outline-none focus:ring-[#888888]"
                      placeholder="Please enter address"
                      rows={4}
                      id="address"
                      color={errors.address ? "danger" : "default"}
                      autoComplete="off"
                    />
                    {typeof errors.address?.message === "string" && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.address.message}
                      </p>
                    )}
                  </>
                )}
              />
            </div>
          </>
        )}
        <div className="mt-4 flex justify-end gap-2">
          <NeoButton type="button" color="white" onClick={() => reset()}>
            Reset
          </NeoButton>
          <NeoButton
            className=""
            type="submit"
            isLoading={isSubmitting}
            spinner={
              <AiOutlineLoading size="xs" className="animate-spin h-6 w-6" />
            }
          >
            Submit
          </NeoButton>
        </div>
      </form>
    </div>
  );
};
